import { categories } from '@/mocks/categories';

export default function CategoryCardGrid() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
      {categories.map((cat) => (
        <a
          key={cat.id}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col items-center rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:shadow-sm transition-all duration-200 cursor-pointer overflow-hidden"
        >
          <div className="w-full h-32 md:h-36 overflow-hidden">
            <img
              src={cat.image}
              alt={cat.name}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
          </div>
          <div className="flex flex-col items-center gap-1.5 p-3 md:p-4 w-full">
            <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
              <i className={`${cat.icon} text-base text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap group-hover:text-primary-600 transition-colors">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500 text-center line-clamp-2 leading-relaxed">
              {cat.description}
            </span>
          </div>
        </a>
      ))}
    </div>
  );
}